// /frontend/src/services/salesService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL}/sales`;

export const salesService = {
  // Get sales report
  getSalesReport: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/report`, { params });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Get sales by product
  getSalesByProduct: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/by-product`, { params });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Get sales by category
  getSalesByCategory: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/by-category`, { params });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Get revenue over time
  getRevenueOverTime: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/revenue`, { params });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Get top customers
  getTopCustomers: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/top-customers`, { params });
      return response.data.data;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  },
  
  // Export report
  exportReport: async (params = {}) => {
    try {
      const response = await apiClient.get(`${API_URL}/export`, { 
        params,
        responseType: 'blob'
      });
      
      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      
      // Set filename based on format
      const format = params.format || 'csv';
      const dateStr = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `sales-report-${dateStr}.${format}`);
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return true;
    } catch (error) {
      throw error.response?.data?.message || error.message;
    }
  }
};